import React, { useState } from "react";
import axios from "axios";
import "./AddInvestor.css";
import Topheader from "../component/Topheader";
import API_URL from "../config";

const AddInvestor = () => {
  const [investorType, setInvestorType] = useState("");
  const [formData, setFormData] = useState({
    email: "",
    linkedinProfile: "",
    contactNumber: "",
    website: "",
    stage: "",
    industry: "",
    skills: [],
    // Angel specific
    investorName: "",
    firmLogo: null,
    pointOfContact: "",
  });
  const [skillInput, setSkillInput] = useState("");

  const stages = ["pre-seed", "seed", "early", "growth", "stage-agnostic"];
  const industries = [
    "AI/ML",
    "Agritech",
    "Consumer",
    "Digital Entertainment",
    "Edtech",
    "Fintech",
    "Healthtech",
    "Media",
    "Mobility",
    "SaaS",
    "Industry Agnostic",
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const submitData = new FormData();

      Object.keys(formData).forEach((key) => {
        if (key === "skills") {
          submitData.append("skills", JSON.stringify(formData.skills));
        } else if (key === "firmLogo" && formData.firmLogo) {
          submitData.append("firmLogo", formData.firmLogo);
        } else if (formData[key]) {
          submitData.append(key, formData[key]);
        }
      });

      submitData.append("investorType", investorType);

      const response = await axios.post(
        `${API_URL}/api/investors`,
        submitData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.success) {
        alert("Investor added successfully!");
        // Optionally reset form
        setFormData({
          email: "",
          linkedinProfile: "",
          contactNumber: "",
          website: "",
          stage: "",
          industry: "",
          skills: [],
          investorName: "",
          investorName: "",
          firmLogo: null,
          pointOfContact: "",
        });
        setInvestorType("");
      }
    } catch (error) {
      console.error("Error:", error);
      alert(
        error.response?.data?.message ||
          "An error occurred while adding the investor"
      );
    }
  };

  const handleSkillInput = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      const newSkill = skillInput.trim();

      if (
        newSkill &&
        !formData.skills.includes(newSkill) &&
        formData.skills.length < 20
      ) {
        setFormData({
          ...formData,
          skills: [...formData.skills, newSkill],
        });
        setSkillInput("");
      }
    }
  };

  const removeSkill = (skillToRemove) => {
    setFormData({
      ...formData,
      skills: formData.skills.filter((skill) => skill !== skillToRemove),
    });
  };

  return (
    <div>
      <div className="investor-container">
          <div className="investor-wrapper">
            <div className="investor-card">
              <h2 className="investor-title">Add Investor</h2>

              <form onSubmit={handleSubmit}>
                <div className="form-grid">
                  {/* Investor Type Selection */}
                  <div className="form-group full-width">
                    <label className="form-label">Investor Type</label>
                    <select
                      value={investorType}
                      onChange={(e) => setInvestorType(e.target.value)}
                      className="form-select"
                      required>
                      <option value="">Select Type</option>
                      <option value="angel">Angel Investor</option>
                      <option value="vc">VC Firm</option>
                    </select>
                  </div>

                  {/* Conditional rendering based on investor type */}
                  {investorType === "angel" && (
                    <>
                      <div className="form-group">
                        <label className="form-label">Investor Name</label>
                        <input
                          type="text"
                          name="investorName"
                          value={formData.investorName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              investorName: e.target.value,
                            })
                          }
                          className="form-input"
                          required
                        />
                      </div>
                    </>
                  )}

                  {investorType === "vc" && (
                    <>
                      <div className="form-group">
                        <label className="form-label">VC Firm Name</label>
                        <input
                          type="text"
                          name="investorName"
                          value={formData.investorName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              investorName: e.target.value,
                            })
                          }
                          className="form-input"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Firm Logo</label>
                        <input
                          type="file"
                          name="firmLogo"
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              firmLogo: e.target.files[0],
                            })
                          }
                          className="form-file-input"
                          accept="image/*"
                          required
                        />
                      </div>{" "}
                      <div className="form-group">
                        <label className="form-label">Point of Contact</label>
                        <input
                          type="text"
                          name="pointOfContact"
                          value={formData.pointOfContact}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              pointOfContact: e.target.value,
                            })
                          }
                          className="form-input"
                          required
                        />
                      </div>
                    </>
                  )}

                  {/* Common fields */}
                  {investorType && (
                    <>
                      <div className="form-group">
                        <label className="form-label">LinkedIn Profile</label>
                        <input
                          type="url"
                          name="linkedinProfile"
                          value={formData.linkedinProfile}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              linkedinProfile: e.target.value,
                            })
                          }
                          className="form-input"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={(e) =>
                            setFormData({ ...formData, email: e.target.value })
                          }
                          className="form-input"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label className="form-label">Contact Number</label>
                        <input
                          type="tel"
                          name="contactNumber"
                          value={formData.contactNumber}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              contactNumber: e.target.value,
                            })
                          }
                          className="form-input"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label className="form-label">Website (Optional)</label>
                        <input
                          type="url"
                          name="website"
                          value={formData.website}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              website: e.target.value,
                            })
                          }
                          className="form-input"
                        />
                      </div>

                      <div className="form-group">
                        <label className="form-label">Stage</label>
                        <select
                          name="stage"
                          value={formData.stage}
                          onChange={(e) =>
                            setFormData({ ...formData, stage: e.target.value })
                          }
                          className="form-select"
                          required>
                          <option value="">Select Stage</option>
                          {stages.map((stage) => (
                            <option key={stage} value={stage}>
                              {stage}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label className="form-label">Industry</label>
                        <select
                          name="industry"
                          value={formData.industry}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              industry: e.target.value,
                            })
                          }
                          className="form-select"
                          required>
                          <option value="">Select Industry</option>
                          {industries.map((industry) => (
                            <option
                              key={industry}
                              value={industry.toLowerCase()}>
                              {industry}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group full-width">
                        <label className="form-label">
                          Skills (Press space or enter to add)
                        </label>
                        <div className="skills-input-container">
                          <input
                            type="text"
                            value={skillInput}
                            onChange={(e) => setSkillInput(e.target.value)}
                            onKeyDown={handleSkillInput}
                            className="form-input"
                            placeholder="Add skills..."
                            maxLength={50}
                          />
                          <div className="skills-tags">
                            {formData.skills.map((skill, index) => (
                              <span key={index} className="skill-tag">
                                {skill}
                                <button
                                  type="button"
                                  onClick={() => removeSkill(skill)}
                                  className="remove-skill">
                                  ×
                                </button>
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {investorType && (
                  <div className="submit-wrapper">
                    <button type="submit" className="submit-button">
                      Add Investor
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    );
};

export default AddInvestor;
